import { render, staticRenderFns } from "./CadastroFinal.vue?vue&type=template&id=649886e6&scoped=true&"
import script from "./CadastroFinal.vue?vue&type=script&lang=js&"
export * from "./CadastroFinal.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFinal.vue?vue&type=style&index=0&id=649886e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649886e6",
  null
  
)

export default component.exports